import type { Client } from '../client';
import type { ChangePasswordRequest } from '../types';

export function settingsEndpoints(client: Client) {
  return {
    changePassword: (data: ChangePasswordRequest) =>
      // Lives under /api/auth so every role can reach it (the admin
      // router is gated to operators/admins).
      client.post<{ ok: boolean }>('/api/auth/change-password', data),
  };
}
